export default {
  mounted(el, binding) {
    const input = el.querySelector('input')
    if (input) {
      const transformToUpper = () => {
        const uppercased = input.value.toUpperCase()
        if (input.value !== uppercased) {
          input.value = uppercased
          input.dispatchEvent(new Event('input'))
        }
      }

      input.addEventListener('input', transformToUpper)
      input.addEventListener('blur', transformToUpper) // <-- handles tab-out edge case
    }
  },
  updated(el, binding) {
    const input = el.querySelector('input')
    if (input && binding.value !== binding.oldValue) {
      const uppercased = binding.value.toUpperCase()
      input.value = uppercased
      input.dispatchEvent(new Event('input'))
    }
  }
}

/* export default {
  mounted(el, binding) {
    const input = el.querySelector('input')
    if (input) {
      input.addEventListener('input', () => {
        const uppercased = input.value.toUpperCase()
        input.value = uppercased
        // input.dispatchEvent(new Event('input'))  // trigger Vue update if necessary
      })
    }
  },
  updated(el, binding) {
    const input = el.querySelector('input')
    if (input && binding.value !== binding.oldValue) {
      const uppercased = binding.value.toUpperCase()
      input.value = uppercased
      input.dispatchEvent(new Event('input'))
    }
  }
}
 */
